import { render, staticRenderFns } from "./CommunitySearchResults.vue?vue&type=template&id=3ccf85b1&scoped=true&"
import script from "./CommunitySearchResults.vue?vue&type=script&lang=js&"
export * from "./CommunitySearchResults.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySearchResults.vue?vue&type=style&index=0&id=3ccf85b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf85b1",
  null
  
)

export default component.exports